import { type RefObject, useMemo } from 'react';

import { useInitMap } from './useInitMap';
import { useInitOwnYandexModulesAndLayers } from './useInitOwnYandexModulesAndLayers';

interface IUseInitYandexMap {
  ymaps: YMaps.IYMaps | null;
  map: YMaps.Map | null;
}

export const useInitYandexMap = (mapRef: RefObject<HTMLDivElement>): IUseInitYandexMap => {
  const ymaps = useInitOwnYandexModulesAndLayers();

  const map = useInitMap({ mapRef, ymaps });

  return useMemo(() => ({ ymaps, map }), [ymaps, map]);
};
